import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { WalletItemBankAccount } from "../../../store/common";
import * as httpClient from "../../../util/httpClient";
import { Notification } from "../../common/Notification";
import { useForm } from "react-hook-form";
import { getFlowByName } from "../../../config/FlowName";
import * as NextStepFlowAction from "../../../store/nextStepFlowService/actions";
import { ApplicationState } from "../../../store";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { PATTERNS } from "../../../util/patterns";
import { useTranslation } from "react-i18next";

const BankAccountDialog: React.FunctionComponent<{ requestDataCallback(): void; walletItem: WalletItemBankAccount; isNew: boolean; closeDialog(): void }> = (
    props
) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [isLoading, setisLoading] = useState(false);
    const dispatch = useDispatch();
    const [bankacc, setBankacc] = useState(props.walletItem);
    const [errorMsg, seterrorMsg] = useState("");
    const [hasError, setHasError] = useState(false);
    const lostWalletFlow = useSelector((state: ApplicationState) => getFlowByName(state, "LOST-WALLET-ASSISTANCE"));
    const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));

    /**Validation with react-hook-form ***/
    const { register, errors, formState, handleSubmit } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });
    const { isSubmitting } = formState;

    useEffect(() => {
        if (props.isNew) {
            setBankacc({ ...bankacc, accountType: "CONSUMER_CHECKING" });
        }
    }, []);

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const refresWalletItem = () => {
        closeDialog();
        props.requestDataCallback();
    };

    function onChnageHandler(event: any) {
        setHasError(false);
        const elName = event.currentTarget.name;
        setBankacc({ ...bankacc, [elName as string]: event.currentTarget.value });
    }

    const saveItem = () => {
        const requestBody = {
            "lost-wallet": {
                "lost-wallet-bankacc": bankacc,
            },
        };
        setisLoading(true);
        httpClient
            .sendRequest("POST", "api/lostWallet/" + (props.isNew ? "addNewWalletItem" : "updateWalletItem"), requestBody)
            .then((data) => {
                setisLoading(false);
                if (data.isSuccess) {
                    if (lostWalletFlow && lostWalletFlow.flowStepStatus !== "COMPLETED") {
                        completeGetStartedItem(lostWalletFlow.flowStepId, lostWalletFlow.flowName ? lostWalletFlow.flowName : " ");
                    }
                    Notification({
                        type: "success",
                        title: props.isNew
                            ? tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.addToastTitle")
                            : tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.updateToastTitle"),
                        message: props.isNew
                            ? tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.addToastMessage")
                            : tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.updateToastMessage"),
                    });
                    refresWalletItem();
                } else if (data.hasError && data.errors.length > 0) {
                    seterrorMsg(data.errors.join(", "));
                    setHasError(true);
                } else {
                    seterrorMsg(tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.unknownError"));
                    setHasError(true);
                }
            })
            .catch(function (error) {
                setisLoading(false);
                Notification({
                    type: "error",
                    title: tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.errorToastTitle"),
                    message: tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.errorToastMesage"),
                    duration: 0,
                });
                closeDialog();
            });
    };

    return (
        <React.Fragment>
            {!isLoading ? (
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <em className={props.isNew ? "las la-plus" : "las la-edit"}></em>
                        </div>
                        <h1>
                            {props.isNew
                                ? tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.addLabel")
                                : tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.editLabel")}{" "}
                            {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.title")}
                        </h1>
                    </div>

                    <form onSubmit={handleSubmit(saveItem)} id="bank-account-form-container">
                        <div className="dialog-body large-dialog-scroll">
                            <div className={errors["accountType"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-type-of-account">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.type")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <select
                                            aria-required="true"
                                            className="inputbox"
                                            id="edit-type-of-account"
                                            aria-labelledby="edit-type-of-account"
                                            name="accountType"
                                            defaultValue={bankacc.accountType}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                required: true,
                                            })}
                                        >
                                            <option value="CONSUMER_CHECKING">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.typeOfAccountList.checkingAccount")}
                                            </option>
                                            <option value="CONSUMER_SAVINGS">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.typeOfAccountList.savingsAccount")}
                                            </option>
                                            <option value="CONSUMER_JOINT_SAVINGS">
                                                {tLang(
                                                    "identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.typeOfAccountList.jointSavingsAccount"
                                                )}
                                            </option>
                                            <option value="COMMERCIAL_CHECKING">
                                                {tLang(
                                                    "identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.typeOfAccountList.commercialCheckingAccount"
                                                )}
                                            </option>
                                            <option value="LINE_CREDIT">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.typeOfAccountList.lineOfCredit")}
                                            </option>
                                            <option value="MONEY_MARKET">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.typeOfAccountList.moneyMarket")}
                                            </option>
                                            <option value="OTHER">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.typeOfAccountList.other")}
                                            </option>
                                        </select>
                                        {errors.accountType && errors.accountType.type === "required" && (
                                            <span className="form-error">Type of Account is required.</span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["institutionName"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-financial-institution-name">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.institutionName")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-financial-institution-name"
                                            aria-labelledby="edit-financial-institution-name"
                                            name="institutionName"
                                            defaultValue={bankacc.institutionName}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                required: true,
                                                pattern: /^[a-zA-Z\s\-\'\&\(\)\,\.]+$/,
                                            })}
                                            maxLength={50}
                                        />
                                        {errors.institutionName && errors.institutionName.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.validationMessage.institution.pattern")}
                                            </span>
                                        )}

                                        {errors.institutionName && errors.institutionName.type === "required" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.validationMessage.institution.required")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["accountNumber"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-account-number">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.acNumber")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-account-number"
                                            aria-labelledby="edit-account-number"
                                            name="accountNumber"
                                            defaultValue={bankacc.accountNumber}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                required: true,
                                                pattern: /^$|^(\d{4,36})$/,
                                            })}
                                            maxLength={36}
                                        />
                                        {errors.accountNumber && errors.accountNumber.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.validationMessage.accountNumber.pattern")}
                                            </span>
                                        )}

                                        {errors.accountNumber && errors.accountNumber.type === "required" && (
                                            <span className="form-error">
                                                {tLang(
                                                    "identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.validationMessage.accountNumber.required"
                                                )}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-address">{tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.address")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <input
                                        type="text"
                                        className="inputbox"
                                        id="edit-address"
                                        aria-labelledby="edit-address"
                                        name="street"
                                        maxLength={100}
                                        defaultValue={bankacc.street}
                                        onChange={onChnageHandler}
                                    />
                                </div>
                            </div>

                            <div className={errors["city"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-city">{tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.city")}</label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-city"
                                            aria-labelledby="edit-city"
                                            name="city"
                                            defaultValue={bankacc.city}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                pattern: PATTERNS.CITY.pattern,
                                            })}
                                            maxLength={20}
                                        />
                                        {errors.city && errors.city.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.validationMessage.city.pattern")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["state"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-state">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.state", {
                                                stateLabel: i18nService.get("State.Label"),
                                            })}
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-state"
                                            aria-labelledby="edit-state"
                                            name="state"
                                            defaultValue={bankacc.state}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                pattern: /^[a-zA-Z.\s]+$/,
                                            })}
                                            maxLength={10}
                                        />
                                        {errors.state && errors.state.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.validationMessage.state.pattern", {
                                                    stateLabel: i18nService.get("State.Label"),
                                                })}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["zip"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-zip">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.zipCode", {
                                                zipCodeLabel: i18nService.get("ZipCode.Label"),
                                            })}
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-zip"
                                            aria-labelledby="edit-zip"
                                            name="zip"
                                            defaultValue={bankacc.zip}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                pattern: /^(?!0{5})(\d{5})(?!-?0{4})(|-\d{4})?$/,
                                            })}
                                        />
                                        {errors["zip"] && errors["zip"].type === "required" && (
                                            <span className="form-error">{i18nService.get("`ZipCode`.Label")} is required.</span>
                                        )}
                                        {errors["zip"] && errors["zip"].type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.validationMessage.zipCode.pattern")}{" "}
                                                {i18nService.get("ZipCode.Pattern") === "ZIPCODE"
                                                    ? `${tLang(
                                                          "identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.validationMessage.zipCode.pattern1",
                                                          { zipCodeLabel: i18nService.get("ZipCode.Label") }
                                                      )}`
                                                    : `${tLang(
                                                          "identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.validationMessage.zipCode.pattern2",
                                                          { zipCodeLabel: i18nService.get("ZipCode.Label") }
                                                      )}`}
                                            </span>
                                        )}
                                        {errors["zip"] && errors["zip"].type === "maxLength" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.validationMessage.zipCode.pattern3", {
                                                    zipCodeLabel: i18nService.get("ZipCode.Label"),
                                                    zipCodeMaxLength: i18nService.get("ZipCode.MaxLength"),
                                                })}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["phoneNumber"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-phone-number">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.phoneNumber")}
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-phone-number"
                                            aria-labelledby="edit-phone-number"
                                            name="phoneNumber"
                                            defaultValue={bankacc.phoneNumber}
                                            onChange={onChnageHandler}
                                            ref={register({
                                                pattern: /^[01]?[- .]?(\([2-9]\d{2}\)|[2-9]\d{2})[- .]?\d{3}[- .]?\d{4}$/,
                                            })}
                                        />
                                        {errors.phoneNumber && errors.phoneNumber.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.validationMessage.phoneNumber.pattern")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-hours">{tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.hours")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <input
                                        type="text"
                                        className="inputbox"
                                        id="edit-hours"
                                        aria-labelledby="edit-hours"
                                        name="hours"
                                        maxLength={30}
                                        defaultValue={bankacc.hours}
                                        onChange={onChnageHandler}
                                    />
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-website">{tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.website")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <input
                                        type="text"
                                        className="inputbox"
                                        id="edit-website"
                                        aria-labelledby="edit-website"
                                        name="website"
                                        maxLength={50}
                                        defaultValue={bankacc.website}
                                        onChange={onChnageHandler}
                                    />
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-notes">{tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.notes")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <textarea
                                        className="inputbox"
                                        id="edit-notes"
                                        aria-labelledby="edit-notes"
                                        name="notes"
                                        maxLength={500}
                                        style={{ resize: "none" }}
                                        placeholder=""
                                        rows={6}
                                        defaultValue={bankacc.notes}
                                        onChange={onChnageHandler}
                                    />
                                </div>
                            </div>

                            {hasError && (
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter"></div>
                                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <p className="form-error">{errorMsg}</p>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="dialog-footer">
                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                                        <span className="btn-text">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.cancelButtonText")}
                                        </span>
                                    </button>
                                </div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="submit" className="btn-default btn-primary" disabled={isSubmitting}>
                                        <span className="btn-text">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.addBankAccountPopup.label.saveButtonText")}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </>
            ) : (
                <div className="box loading"></div>
            )}
        </React.Fragment>
    );
};

export default BankAccountDialog;
